import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import useLoggedInRedirect from 'src/auth/hooks/useLoggedInRedirect';
import Root from './components/Root';
import { PAGES } from './constants';
import {
  Contact,
  Password,
} from './components/pages';
import PageNotFound from '../common/components/NotFoundContent';

export const BookingRoutes: FC = props => {
  useLoggedInRedirect();
  const { url } = useRouteMatch();

  return (
    <Root {...props}>
      <Switch>
        <Route
          exact
          path={`${url}/${PAGES.CONTACT}/`}
        >
          <Contact />
        </Route>
        <Route
          path={`${url}/${PAGES.PASSWORD}/`}
        >
          <Password />
        </Route>
        <Route
          render={renderProps => (
            <PageNotFound
              {...renderProps}
              classNameModifier="modal"
            />
          )}
        />
      </Switch>
    </Root>
  );
};

export default BookingRoutes;
